import React from 'react';

interface LiveMarkerSvgProps {
  backgroundColor: string;
  isReplay?: boolean;
}

/**
 * Live marker - diamond shape with "LIVE" text and white border
 * Ported from ui/src/components/markers/LiveMarkerSvg.tsx
 */
export const LiveMarkerSvg: React.FC<LiveMarkerSvgProps> = ({ backgroundColor, isReplay = false }) => {
  return (
    <div style={styles.liveMarkerContainer}>
      <div style={styles.markerInnerContainer}>
        <div style={styles.combinedContainer}>
          <svg width="56" height="52" viewBox="0 0 56 52">
            {/* White border - outer diamond */}
            <path d="M 28,0 L 54,26 L 28,52 L 2,26 Z" fill="white" />
            {/* Colored fill - inner diamond */}
            <path d="M 28,2 L 52,26 L 28,50 L 4,26 Z" fill={backgroundColor} />
          </svg>
          <div style={styles.textOverlay}>
            <span style={isReplay ? styles.liveReplayText : styles.liveText}>
              {isReplay ? 'LIVE\nREPLAY' : 'LIVE'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  combinedContainer: {
    height: 52,
    width: 56,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative' as const,
  },
  liveMarkerContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    height: 52,
    justifyContent: 'center',
    width: 56,
  },
  liveReplayText: {
    color: 'white',
    fontSize: 7,
    fontWeight: 'bold' as const,
    textAlign: 'center' as const,
    whiteSpace: 'pre-line' as const,
    marginTop: -4,
    marginLeft: 1,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  },
  liveText: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold' as const,
    textAlign: 'center' as const,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  },
  markerInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative' as const,
  },
  textOverlay: {
    position: 'absolute' as const,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: 20,
  },
};
